export function encode64(value: string) {
  return window.btoa(window.unescape(window.encodeURIComponent(value)));
}
export function decode64(value: string) {
  return window.decodeURIComponent(window.escape(window.atob(value)));
}

/**
 * Creates token from object values. Token will remain same if object values are same
 * @param obj object
 */
export function tokenize(obj) {
  return encode64(JSON.stringify(obj));
}
/**
 * Parses token to object
 * @param obj string
 */
export function deTokenize<T>(obj) {
  return JSON.parse(decode64(obj)) as T;
}
